import React from 'react';
import Navbar from './Navbar';
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from './Footer';

const PrivacyPolicy = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <div>PrivacyPolicy</div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;